module.exports = __webpack_public_path__ + "img/benefit-05-iot-4.f0441031.png";